import { useTrackingAvDistributionType, useTrackingEventsDatas } from "@/hooks";
import { useTrackingEvent } from "./useTrackingEvent";
export const useTrackingLeadInterestPhone = (av_zone) => {
    const distributionType = useTrackingAvDistributionType();
    const EVENT_DATA = Object.assign({ event: distributionType === "1"
            ? "lead_classified_phone_display_rent"
            : "lead_classified_phone_display_buy", av_zone }, useTrackingEventsDatas({
        displayMedium: true,
        conversionType: "phone",
    }));
    // @ts-ignore
    return useTrackingEvent(EVENT_DATA);
};
